import React, { useState } from 'react';
import { Box, Typography, Paper, Container, Slider, Stack } from '@mui/material';
import HeightIcon from '@mui/icons-material/Height';

const Hanging: React.FC = () => {
  const [hangingHeight, setHangingHeight] = useState<number>(50);

  const handleHeightChange = (event: Event, newValue: number | number[]) => {
    setHangingHeight(newValue as number);
  };

  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Hanging
        </Typography>
        <Box 
          sx={{ 
            width: '100%', 
            height: '200px', 
            bgcolor: 'grey.200', 
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Box 
            sx={{ 
              width: '80px', 
              height: '100px', 
              bgcolor: 'primary.light',
              position: 'absolute',
              top: `${hangingHeight}px`,
              transition: 'top 0.3s ease'
            }}
          />
          <Typography 
            variant="body2" 
            sx={{ 
              position: 'absolute', 
              bottom: 5, 
              right: 5, 
              color: 'text.secondary' 
            }}
          >
            Height: {hangingHeight}px
          </Typography>
        </Box>
        
        <Stack 
          direction="row" 
          spacing={2} 
          alignItems="center" 
          sx={{ width: '100%', mt: 2 }}
        >
          <HeightIcon />
          <Slider
            value={hangingHeight}
            onChange={handleHeightChange}
            aria-labelledby="hanging-height-slider"
            min={0}
            max={100}
          />
          <HeightIcon sx={{ transform: 'rotate(180deg)' }} />
        </Stack>
      </Paper>
    </Container>
  );
};

export default Hanging; 